import { EventEmitter } from 'events';

export enum NotificationSeverity {
  INFO = 0,
  SUCCESS = 1,
  ERROR = 2,
}

export type Notification = {
  severity: NotificationSeverity;
  message: string;
};

class NotificationService extends EventEmitter {
  constructor() {
    super();
    this.show = this.show.bind(this);
    this.success = this.success.bind(this);
  }

  info(message: string) {
    this.show({
      message,
      severity: NotificationSeverity.INFO,
    });
  }

  success(message: string) {
    this.show({
      message,
      severity: NotificationSeverity.SUCCESS,
    });
  }

  error(message: string) {
    this.show({
      message,
      severity: NotificationSeverity.ERROR,
    });
  }

  show(notification: Notification) {
    notification.severity = notification.severity || NotificationSeverity.INFO;

    switch (notification.severity) {
      case NotificationSeverity.SUCCESS:
        notification.severity = 1;
        break;
      case NotificationSeverity.ERROR:
        notification.severity = 2;
        break;
    }

    this.emit('show', notification);
  }
}

export default new NotificationService();
